import React, { useEffect, useRef, useState } from 'react';
import { Wrapper } from './styles';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";
import { Button } from '../../reusable-components';
import { operatorAdviceErrorOccurred, operatorAdviceBetSuccess } from "../../App";
import { PoolXNumberFormat } from '../../common/CurrencyFormatter';
import { IsComeOn, themeC } from '../../theme/themehelper';
import { ComeOnReceipt } from '../../images/comeonicons';
import { Grid } from '@mui/material';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import { track, trackPurchase } from '../../analytics/analytics';

function renderSwitch({
  shouldRenderConfirm,
  toggle,
  syndicate,
  phrases,
  handleClick,
  errorResponse,
  buttonEnabled,
  t
}) {

  var enabled = buttonEnabled;

  let locale = t('locale');
  const nf = PoolXNumberFormat(locale, { style: 'currency', currency: syndicate.totalAmountPerShare.currency, minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const onConfirmClick = (syndicate) => {
    if (enabled) {
      handleClick(syndicate);
      enabled = false;
    }
  }

  if (shouldRenderConfirm) {

    if (errorResponse !== undefined) {
      return (
        <>
          <span>{errorResponse}</span>
          <Button width={200} onClick={() => toggle(false)}>Ok</Button>
        </>
      );
    }

    return (
      <>
        <span>{phrases.paymentDone}</span>
        <Button width={200} onClick={() => toggle(false)}>Ok</Button>
      </>
    );
  }

  return (
    <>
      <span>{phrases.confirmPurchase} {nf.format(syndicate.totalAmountPerShare.amount)}?</span>
      <Button enabled={enabled} type="submit" width={200} onClick={() => onConfirmClick(syndicate)}>{phrases.pay}</Button>
    </>
  );
}

const SyndicateConfirm = ({
  syndicate,
  toggle,
  purchase
}) => {
  const [shouldRenderConfirm, setShouldRenderConfirm] = useState(false);
  const [errorResponse, setErrorResponse] = useState(undefined);
  const [buttonEnabled, setbuttonEnabled] = useState(true);
  const wrapperRef = useRef(null);
  const [iconColor, setIconColor] = useState("black");

  useEffect(() => {
      if (wrapperRef.current) {
        const styles = getComputedStyle(wrapperRef.current);
        const color = styles.getPropertyValue('--text-black').trim();
        if (window.theme === themeC.ComeOn) {
          setIconColor("#C0F9C8");
        }
        else if (color) setIconColor(color);
      }
    }, []);


  const { t } = useTranslation();
  const phrases = {
    confirmPurchase: t('do_you_want_to_place_bet'),
    pay: t('pay_syndicate'),
    paymentDone: t('your_bet_is_paid'),
    insufficientFunds: t('insufficient_funds'),
    gamingLimitsReached: t('gaming_limits_reached'),
    unableToCompletePurchase: t('unable_to_complete_purchase'),
  };

  const handleClose = () => {
    toggle(false);
  }

  const handleClick = (syndicate) => {
    setbuttonEnabled(false);
    purchase().then(resp => {
      return resp.json();
    }).then(j => {

      if (j.errorCode !== undefined) {
        let errorText = phrases.unableToCompletePurchase;

        if (j.localizedOperatorMessage !== undefined && j.localizedOperatorMessage !== '') {
          errorText = j.localizedOperatorMessage
        }

        switch (j.errorCode) {
          case 101:
            errorText = phrases.unableToCompletePurchase; // TODO replace with 'session expired'
            break;
          case 102:
            errorText = phrases.insufficientFunds;
            break;
          case 105:
            errorText = phrases.gamingLimitsReached;
            break;
          default:
            break;
        }

        operatorAdviceErrorOccurred({
          errorCode: j.errorCode,
          errorMessage: errorText,
          operatorErrorCode: j.operatorErrorCode,
        })
        track("bet_failed", { error_code: j.errorCode, operator_error_code: j.operatorErrorCode, bet_type: "syndicate" });
        setErrorResponse(errorText);
      }
      else if (j && j.couponShareId) {
        operatorAdviceBetSuccess({
          type: "bet_success",
          amount: j.totalStake?.amount,
          currency: j.totalStake?.currency,
          transactionId: j.transactionId,
          roundId: j.roundId,
        });
        trackPurchase({
          amount: j.totalStake?.amount,
          currency: j.totalStake?.currency,
          roundId: j.roundId,
          transactionId: j.transactionId,
          couponShareId: j.couponShareId,
        }, "syndicate", undefined, 1);
      }
      setShouldRenderConfirm(true);
      setbuttonEnabled(true);
    });
  } 

  return (
    <Wrapper ref={wrapperRef}>
      <div className="onclick-div" onClick={handleClose} />
      <div className="confirm-window">
        <div className="flex-end">
          <CloseIcon className="close-icon" onClick={handleClose} />
        </div>
        <div className='icon-holder'>
        {(IsComeOn(window.theme)) ?
              <Grid>{ComeOnReceipt(51,50,iconColor)}</Grid> :
              <ReceiptOutlinedIcon sx={{ color: iconColor }} fontSize='inherit' />
        }
        </div>
        {renderSwitch({
          shouldRenderConfirm,
          toggle,
          syndicate,
          phrases,
          handleClick,
          errorResponse,
          buttonEnabled,
          t
        })}
      </div>
    </Wrapper>
  );
}

export default SyndicateConfirm;